import { Box, Typography } from "@mui/material";
import styled from "styled-components";

export const Header = styled(Box)`
  color: ${({ theme }) => theme.palette.text.primary};
  background-color: ${({ theme }) => theme.palette.background.headerPanel};
  width: 100%;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 20px;
`;
export const LabelHeader = styled(Typography)`
  font-size: 27px !important;
`;
export const SubLabelHeader = styled(Typography)`
  font-size: 20px !important;
`;
export const BoxValue = styled(Box)`
  background: #262626;
  border-radius: 8px;
  padding: 5px 10px;
  min-width: 100px;
  text-align: right;
  font-size: clamp(16px, 4vw, 22px);
  font-weight: 800;
`;

export const BoxCost = styled(Box)`
  background: #262626;
  border-radius: 8px;
  padding: 5px 10px;
  min-width: 120px;
  text-align: right;
  font-size: clamp(16px, 4vw, 22px);
  font-weight: 800;
`;

export const PanelBody = styled(Box)`
  background-color: ${({ theme }) => theme.palette.background.bodyPanel};
  padding: 10px 15px;
  padding-bottom: 25px;
  border-radius: 8px;
  overflow: hidden;
`;
